import { useEffect, useMemo, useState } from 'react'
import { Outlet, ScrollRestoration, } from 'react-router-dom'
import Header from 'components/Header'
import Footer from 'components/Footer'
import cn from 'utils/cn'

export default function Main() {


    return (
        <div
            style={{ fontFamily: "Barlow, 'gf_Noto_Sans_SC', sans-serif" }}
            id='main-container'
        >
            <Header />
            <div className='pt-[53.8px]'> <Outlet /></div>
            <ScrollRestoration />
            <Footer />
        </div>
    )
}
